import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableMapSet } from 'immer';
import { environment } from '@coin/shared/core/util-environments';
import { AppModule } from './app/app.module';

// Immer resolves its Map/Set support lazily from inside a proxy get trap, so the plugin
// must be registered before the first `produce` that drafts a Map or Set (GMTEC-24514).
enableMapSet();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
